import { ModuleWithProviders }   from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const appRoutes: Routes = [
 /*{path: '',
    redirectTo:'/wb',
    pathMatch: "full" 
},
{path: "test", component: SimpleComponent},
  { path: '**', component: SimpleComponent }*/
];

export const appRoutingProviders: any[] = [
   
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes,{ useHash: true });
  


// WEBPACK FOOTER //
// /app/src/app/app.routing.ts